import * as React from "react";
import Accordion, {
  AccordionSlots,
  accordionClasses,
} from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails, {
  accordionDetailsClasses,
} from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import Fade from "@mui/material/Fade";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Box } from "@mui/system";
import { Divider } from "@mui/material";

interface AccordionTransitionProps {
  children?: React.ReactNode;
  title?: string;
}

export default function AccordionTransition({
  children,
  title,
}: AccordionTransitionProps) {
  const [expanded, setExpanded] = React.useState(false);

  const handleExpansion = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };

  return (
    <div>
      <Accordion
        expanded={expanded}
        onChange={handleExpansion}
        slots={{ transition: Fade as AccordionSlots["transition"] }}
        slotProps={{ transition: { timeout: 400 } }}
        sx={[
          {
            backgroundColor: "#f8f9f9",
            boxShadow: "none",
          },
          expanded
            ? {
                [`& .${accordionClasses.region}`]: {
                  height: "auto",
                },
                [`& .${accordionDetailsClasses.root}`]: {
                  display: "block",
                },
              }
            : {
                [`& .${accordionClasses.region}`]: {
                  height: 0,
                },
                [`& .${accordionDetailsClasses.root}`]: {
                  display: "none",
                },
              },
        ]}
      >
        <AccordionSummary aria-controls="panel1-content" id="panel1-header">
          <Typography
            sx={{
              color: "rgba(0, 179, 181, 1)",
              fontSize: "16px",
              fontWeight: "600",
              lineHeight: "24px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {!expanded ? "View" : "Hide"} {title}{" "}
            {!expanded ? (
              <KeyboardArrowDownIcon sx={{ marginLeft: "8px" }} />
            ) : (
              <KeyboardArrowUpIcon sx={{ marginLeft: "8px" }} />
            )}
          </Typography>
        </AccordionSummary>
        <Divider />
        <AccordionDetails>
          <Box>{children}</Box>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
